import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface Response {
  enable_solicitation: boolean
  enable_details: boolean
  max_appointment: number
  available_credits: number
  date_created: string 
  start_date: string
  end_date: string
  status: string
  plan: {
    id: number
    code: string
    name: string
    group: {
      code: string
      name: string
    }
  }
}

export const getEnterpriseEligibility = async({ username, planCode }) => {
  const { data } = await axios.get<Response>(apiEndpoints.PERSON_VALIDITIES(username, planCode))
  
  return data
}